module.exports = __webpack_public_path__ + "img/list_CommIllustration_04.b8ab69fd.jpeg";